// extracted by mini-css-extract-plugin
module.exports = {"container":"phoneframe_container__KZk8K","headerName":"phoneframe_headerName__2FwA7","chatBox":"phoneframe_chatBox__3UPOq","containerSmall":"phoneframe_containerSmall__3EDjU"};